import React from "react";
import TeacherProfileTable from "../Table/TeacherProfileTable";
import TeacherProfileTableFUHSD from "../Table/TeacherProfileTableFUHSD";

export default function MyCourseSection({
  t,
  ChangeImage,
  setAddLeader,
  leaderData,
  parsedUserProfile,
  updateLeader,
  deactivateLeader,
  activateLeader,
}) {
  return (
    <div>
      <div id="section2" className="relative w-full text-center">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-gray-300"></div>
        </div>
        <span className="relative bg-[var(--bg)] px-3 text-lg font-bold text-[var(--brand)] uppercase tracking-wider">
          {t("user_home.my_course")}
        </span>
      </div>
      <div className="flex gap-5 justify-between">
        <p className="w-[calc(100% - 100px)]">
          {t("user_home.add_new_course")}
        </p>
        <button className="flex justify-end w-[30%]">
          <img
            src={ChangeImage}
            alt="addCourse"
            className="md:w-[40px] md:h-[40px]"
            onClick={() => setAddLeader(true)}
          />
        </button>
      </div>
      <div className="flex flex-col gap-10">
        {parsedUserProfile?.affiliation === "FUHSD" ? (
          <TeacherProfileTableFUHSD
            TABLE_ROWS={leaderData}
            affiliation={parsedUserProfile?.affiliation}
            update={(
              trainingLanguage,
              teaching_language_skill_level,
              changeIntroduction,
              interested_topics,
              creditAdjustmentRate,
              index
            ) =>
              updateLeader(
                trainingLanguage,
                teaching_language_skill_level,
                changeIntroduction,
                interested_topics,
                creditAdjustmentRate,
                index
              )
            }
            deactivate={(index) => deactivateLeader(index)}
            activate={(index) => activateLeader(index)}
          />
        ) : (
          <TeacherProfileTable
            TABLE_ROWS={leaderData}
            affiliation={parsedUserProfile?.affiliation}
            update={(
              trainingLanguage,
              teaching_language_skill_level,
              changeIntroduction,
              interested_topics,
              creditAdjustmentRate,
              index
            ) =>
              updateLeader(
                trainingLanguage,
                teaching_language_skill_level,
                changeIntroduction,
                interested_topics,
                creditAdjustmentRate,
                index
              )
            }
            deactivate={(index) => deactivateLeader(index)}
            activate={(index) => activateLeader(index)}
          />
        )}
      </div>
    </div>
  );
}
